import { ReactNode, useMemo } from "react";
import { NavBar } from "@/components/NavBar";
import NavBarItemPlain from "@/components/NavBar/Item/Plain";
import menuNavBar from "./menuNavBar";
import { themeTextColor } from "@/utils/colorConstant";
import { useNavigate } from "react-router-dom";
import { RouteConstant } from "@/routes/routeConstant";

type Props = {
  children: ReactNode;
  isAdmin?: boolean;
};

export const Layout = ({ children, isAdmin }: Props) => {
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigate(isAdmin ? RouteConstant.Account : RouteConstant.Posts);
  };

  const menu = useMemo(() => {
    return menuNavBar({ isAdmin });
  }, []);

  return (
    <div className={`overflow-hidden lg:overflow-visible`}>
      <div
        className={`pt-14 min-h-screen w-screen transition-position lg:w-auto bg-gray-50 dark:bg-slate-800 dark:text-slate-100`}
      >
        <NavBar menu={menu} className="">
          <NavBarItemPlain
            display="hidden lg:flex xl:flex"
            onClick={goToDashboard}
          >
            <h1 className={`leading-relaxed text-3xl`}>
              <span className={` ${themeTextColor}`}>AAS</span>
              <span className="text-[#f77b4f]">PASS</span>
              <span className={` ${themeTextColor}`}>HUB</span>
            </h1>
          </NavBarItemPlain>
        </NavBar>
        {children}
      </div>
    </div>
  );
};
